export const TableItemPlug = () => (
  <div className="p-[10px] mb-[10px] decoration-0 w-full bg-darkBlueOpacity rounded-lg justify-between items-center grid gap-y-2 grid-rows-[max_50px] md:grid-rows-1 grid-cols-[calc(100%-60px)_60px] tableItem">
    <div className="order-1 flex flex-row items-center w-full h-full">
      <span className="w-[100px] h-[20px] bg-darkBlueOpacity3 tableItemPlug" />
    </div>
    <div className="order-3 flex flex-col">
      <div className="flex items-center mb-[10px]">
        <div className="h-[25px] w-[25px] bg-darkBlueOpacity3 rounded-full tableItemPlug" />
        <div className="ml-2 bg-darkBlueOpacity3 w-[75px] h-[20px] tableItemPlug" />
      </div>
      <div className="flex items-center">
        <div className="h-[25px] w-[25px] bg-darkBlueOpacity3 rounded-full tableItemPlug" />
        <div className="ml-2 bg-darkBlueOpacity3 w-[75px] h-[20px] tableItemPlug" />
      </div>
    </div>
    <div className="order-2 md items-center flex justify-end w-full h-full">
      <div className="bg-darkBlueOpacity3 rounded-[8px] w-full h-[24px] tableItemPlug" />
    </div>
  </div>
  );
